/**
 * @module api/prolific
 * @description API client for Prolific integration endpoints.
 */

import axios from "axios";
import { API_BASE_URL, ENDPOINTS } from "../config/apiConfig";

/**
 * Request mode assignment for a Prolific participant.
 * The backend uses round-robin counter-balancing per study.
 * @param {string} studyId - Prolific STUDY_ID
 * @param {string} prolificPid - Prolific PROLIFIC_PID
 * @returns {Promise<{assigned_mode: string}>}
 */
export const getAssignedMode = async (studyId, prolificPid) => {
  const { data } = await axios.post(
    `${API_BASE_URL}${ENDPOINTS.PROLIFIC_CONFIG}`,
    { study_id: studyId, prolific_pid: prolificPid }
  );
  return data;
};

/**
 * Mark a participant as complete and get the Prolific redirect URL.
 * @param {string} prolificPid - Prolific PROLIFIC_PID
 * @param {string} studyId - Prolific STUDY_ID
 * @returns {Promise<{redirect_url: string}>}
 */
export const markComplete = async (prolificPid, studyId) => {
  const { data } = await axios.post(
    `${API_BASE_URL}${ENDPOINTS.PROLIFIC_COMPLETE}`,
    { prolific_pid: prolificPid, study_id: studyId }
  );
  return data;
};

/**
 * Validate Prolific URL parameters.
 * @param {string} pid - PROLIFIC_PID
 * @param {string} studyId - STUDY_ID
 * @returns {Promise<{valid: boolean}>}
 */
export const validateProlificParams = async (pid, studyId) => {
  const { data } = await axios.get(
    `${API_BASE_URL}${ENDPOINTS.PROLIFIC_VALIDATE}`,
    { params: { prolific_pid: pid, study_id: studyId } }
  );
  return data;
};
